import React, { Component } from "react";
import {
  Modal,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { TextField } from "@rmwc/textfield";
import { connect } from "react-redux";
import { Select } from "@rmwc/select";
import * as actionCreator from "../../../action/quote_order/quote.action.js";
import * as validate from "../validations";
import ThankYou from "../ThankYou";
import Questions from "./Questions";
import CommonPromptBox from "../CommonPromptBox";
import AnimButton from "../../Button/AnimButton.js";
import { Checkbox } from "@rmwc/checkbox";
import CurrencyFormat from "react-currency-format";

class SaveLater extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
         showSenseiId: false,
         showModal: false
    };
  }
  
   showHideSenseiId = () => {
      this.setState({ showSenseiId: !this.state.showSenseiId});
   };

   custom(){
      document.getElementsByClassName("modal")[0].style.transform = "scale(0)"
      document.getElementsByClassName("modal")[0].style.transition = "0.6s"
      setTimeout(() => {
         this.props.handleSaveLatter('close')
      },500)
   }

  closeModal = () => {
    this.setState({ showModal: false, closeModalCancel: true });
    this.custom()
  };

  render() {
    let chkPrice = false;
    if (
      this.props.building_Data &&
      this.props.building_Data.down_payment_discount_total != undefined &&
      parseFloat(this.props.building_Data.down_payment_discount_total) != 0
    ) {
      chkPrice = true;
    }
    if (
      this.props.building_Data &&
      this.props.building_Data.discount_amount != undefined &&
      parseFloat(this.props.building_Data.discount_amount) != 0
    ) {
      chkPrice = true;
    }
    if(this.props.loginSession === false  && this.props.hide_price_calculation == 1 ){
       chkPrice = false;
    }
    let CustomTextLD = "";
    if (this.props.crmSetting.main_domain_url != "ldbuildings.com") {
      if (this.props.crmSetting.customText != undefined) {
        CustomTextLD =
          "to proceed with the " +
          this.props.crmSetting.customText +
          " of this building";
      } else {
        CustomTextLD = "to proceed with the installation of this building.";
      }
    }

    let isPreQuoteLoader =
      this.props.crmSetting.pre_quote_form == true &&
      this.props.preQuoteApiCalled == true &&
      this.props.preQuoteError == false &&
      this.props.post_data &&
      this.props.post_data.full_name != undefined &&
      this.props.post_data.full_name != "" &&
      this.props.showStateOnly == false
        ? true
        : false;

   let savingPrice = 0
   if(this.props.building_Data != undefined){
      savingPrice = parseFloat(this.props.building_Data.down_payment_discount_total) + parseFloat(this.props.building_Data.discount_amount);
   }
   
   let upto = 0 
   if(this.props.saveLatterModal && this.props.stopLoader == false){
      let counts = setInterval( () => {
         let count = document.getElementById("counter");
         if(count !== undefined && count != null && count.innerHTML !== undefined && count.innerHTML != null){
            count.innerHTML = upto < 100 ? ++upto : upto;
         }
         if (upto == 100) {
            clearInterval(counts);
         }
      },50);
   }

   if(this.state == null || this.state.closeModalCancel == undefined){
      this.state.showModal = this.props.thankYouForSaveLater
   }else{
      if(this.props.const_var.leadCreatedSuccessfully && this.props.const_var.crmSetting.main_domain_url == 'metalcarportdepotllc.com'){
         this.state.showModal = true
      }else{
         this.state.showModal = false
      }
   }

   return (
   <div>
      <Modal
         centered
         show={this.props.saveLatterModal}
         backdrop="static"
         keyboard={false}
         onHide={(e) => this.custom()}
         dialogClassName={this.props.crmSetting.main_domain_url == "keensbuildings.com" ? "save-later-modal react-modal keens-save-later-modal" : "save-later-modal react-modal"} 
         backdropClassName="ract-modal-pre-parent"
      >

         <Modal.Body className="save-form-after">
            <div className={(this.props.i_g_A_y.length > 5 && isPreQuoteLoader == false || this.props.createLeadOnly) ? "save-later-wrapper": (this.props.crmSetting.main_domain_url == "keensbuildings.com" ? "save-later-wrapper spinner-active" : "save-later-wrapper spinner-active")}
               >
               <div className={this.props.crmSetting.main_domain_url == "keensbuildings.com" ? "spinner-loading-container keens-spinner-loading-container" : "spinner-loading-container"}>
                  <div className="spinner-loading">
                     <div className="spinner"></div>
                     <div className="spinner-value"><span id="counter">0</span>%</div>
                  </div>

                  <div className="spinner-content">
                     <h6 className="spinner-title">Please Wait...</h6>
                     <div className="spinner-text">
                        Hey! We’ll take pictures of this building to attach to the
                        quote/order. It’s nice to be on the same page. Please don’t
                        refresh the page or go back; It won’t take long.
                     </div>
                  </div>
                  <div className="spinner-bottom">
                     Thank you for your patience & cooperation!
                  </div>
               </div>
               <div className="form-container">
                  <button className="close" onClick={(e) => this.custom()}>
                     <span className="icon-close"></span>
                  </button>
                  {
                     parseFloat(savingPrice) > 0 && (this.props.const_var.createLeadOnly && this.props.const_var.crmSetting.main_domain_url == 'metalcarportdepotllc.com' ? false : true) &&
                     <div className={ chkPrice == true ? "save-later-discount mobile-save-later-discount" : "d-none save-later-discount mobile-save-later-discount" }>
                        <i className="icon-discount-ico"></i>
                        <div>
                           <div className="save-later-discount-value">
                              <span className="save-later-discount-title">Your savings on this building - &nbsp; </span>
                              {this.props.building_Data && (
                                 <h3>
                                    <CurrencyFormat fixedDecimalScale decimalSeparator="." decimalScale="2"  value={savingPrice} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                 </h3>
                              )}
                           </div>
                           <div className="save-later-discount-info">
                              Please note that this discount is applicable for a short period only.
                           </div>
                        </div>
                     </div>
                  }

               <div className={this.props.const_var?.estimator_QuestionAnswer?.length > 0 ? (this.props.crmSetting.main_domain_url == "keensbuildings.com" ? "scroll-container keens-scroll-container" : (this.props.const_var.createLeadOnly ? "scroll-container height-auto" : "scroll-container")) : (this.props.const_var.createLeadOnly ? "scroll-container-without-question height-auto" : "scroll-container-without-question")} >
                  <div className={ parseFloat(savingPrice) > 0 && chkPrice == true ? (this.props.crmSetting.main_domain_url == "keensbuildings.com" ? "save-title mobile-save-title-margin keens-mobile-save-title-margin" : (this.props.const_var.createLeadOnly && this.props.const_var.crmSetting.main_domain_url == 'metalcarportdepotllc.com' ? "save-title" : "save-title mobile-save-title-margin")) : "save-title"}>
                  {this.props.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" ? "Save & Submit for Pricing" : this.props.crmSetting.customTextOrder != undefined
                     ? this.props.crmSetting.customTextOrder
                     : (this.props.const_var.crmSetting.main_domain_url == 'metalcarportdepotllc.com' ? "Information Required For Your Quote/Order" : "Save for Later")}
                  </div>

                  {
                     this.props.crmSetting.main_domain_url == "keensbuildings.com" 
                     ?
                     <>
                        <div className="main-finance-div mb-3">
                           <div className="form-group col-md-12 col-sm-12 keen-build p-0 mt-1 mb-1">
                              <span className="finance-title">Financing Offers:</span>
                              <Checkbox className="secondary ml-2" 
                                       ripple="RipplePropF"
                                       id="interestedRTO"
                                       checked={this.props.enableFinanceRTO}  
                                       label="Interested in Financing/RTO" 
                                       onChange={e => this.props.keenBuildingRTO(!this.props.enableFinanceRTO)}
                                 />
                           </div>
                           <div className="finance-points">
                              <span className="points">$0 Down <br/>Financing</span>
                              <span class="vertical-line"></span>
                              <span className="points">Interest Free <br/>(Same as Cash)</span>
                              <span class="vertical-line"></span>
                              <span className="points">Rent to Own <br/>(No Credit Check)</span>
                           </div>
                        </div>
                     </>
                     :
                        null
                  }
                  {
                     this.props.crmSetting.main_domain_url != "keensbuildings.com" 
                     ?
                        this.props.crmSetting.main_domain_url != "idealsteelbuildingsofca.com" 
                        ?
                           <div className="save-text">
                              {
                                 this.props.const_var.crmSetting.main_domain_url == 'metalcarportdepotllc.com'  
                                 ? 
                                    <>
                                       Please provide your contact information so we can accurately prepare your quote/order. 
                                    </>
                                 :
                                    <>
                                       We will email you a PDF with this building’s features and
                                       total price. You can anytime call us at{" "}
                                       <span>{this.props.crmSetting.phone_number}{" "}</span>
                                       {CustomTextLD} 
                                    </>
                              }
                           </div>
                        :
                        <>                   
                           <div className="save-text">
                              Once you complete the form below, a PDF with your building design details and a link to view your 3D design will be sent to your email instantly. A member of our team will then review your design and provide a detailed quote within 2–3 business days.
                           </div>
                             <div className="save-text">
                             Please note, your information will only be used by Ideal Steel Buildings in connection with your metal building purchase and will never be shared or sold.
                          </div>
                        </>
                     :                    
                     null
                  }
                  

                  <form className={this.props.orderLaterSubmitBtn ? "form-submiting" : ""} id="configuration" name="configuration" onSubmit={(e) => {e.preventDefault();this.props.onSubmit(e)}}>
                     <div className={this.props.crmSetting.main_domain_url == "keensbuildings.com" ? "row form-content mb-0" : "row form-content"}>
                        <div className="form-group col-md-6 col-sm-12">
                           <div className="form-label">First Name</div>
                           <div
                           className={
                              this.props.displayerrorMessage.first_name == "" ||
                              this.props.displayerrorMessage.first_name == undefined
                                 ? "floating-label-input"
                                 : "floating-label-input invalid-input"
                           }
                           >
                           <TextField
                              className="astrick"
                              name="first_name"
                              placeholder="e.g. Andrew"
                              onChange={(e) =>
                                 this.props.onquoteTextFiledChangeValue(
                                 e,
                                 "first_name",
                                 "First Name"
                                 )
                              }
                              onBlur={(e) =>
                                 this.props.onquoteTextFiledChangeValue(
                                 e,
                                 "first_name",
                                 "First Name"
                                 )
                              }
                           />
                           <span className="error-icon icon-info-ico"></span>
                           <div className="errorMessage" id="fnameErrorMessage">
                              {this.props.displayerrorMessage.first_name}
                           </div>
                           </div>
                        </div>
                        <div className="form-group col-md-6 col-sm-12">
                           <div className="form-label">Last Name</div>
                           <div
                           className={
                              this.props.displayerrorMessage.last_name == "" ||
                              this.props.displayerrorMessage.last_name == undefined
                                 ? "floating-label-input"
                                 : "floating-label-input invalid-input"
                           }
                           >
                           
                           <TextField
                              className="astrick"
                              name="last_name"
                              placeholder="e.g. Williams"
                              onChange={(e) =>
                                 this.props.onquoteTextFiledChangeValue(
                                 e,
                                 "last_name",
                                 "Last Name"
                                 )
                              }
                              onBlur={(e) =>
                                 this.props.onquoteTextFiledChangeValue(
                                 e,
                                 "last_name",
                                 "Last Name"
                                 )
                              }
                           />
                           <span className="error-icon icon-info-ico"></span>
                           <div className="errorMessage" id="fnameErrorMessage">
                              {this.props.displayerrorMessage.last_name}
                           </div>
                           </div>
                        </div>
                        <div className="form-group col-md-6 col-sm-12">
                           <div className="form-label">Email</div>
                           <div
                           className={
                              this.props.displayerrorMessage.email == "" ||
                              this.props.displayerrorMessage.email == undefined
                                 ? "floating-label-input"
                                 : "floating-label-input invalid-input"
                           }
                           >
                           <TextField
                              className="astrick"
                              name="email"
                              placeholder="e.g. andrew.williams@gmail.com"
                              onChange={(e) =>
                                 this.props.onquoteTextFiledChangeValue(
                                 e,
                                 "email",
                                 "Email"
                                 )
                              }
                              onBlur={(e) =>
                                 this.props.onquoteTextFiledChangeValue(
                                 e,
                                 "email",
                                 "Email"
                                 )
                              }
                           />
                           <span className="error-icon icon-info-ico"></span>
                           <div className="errorMessage" id="emailErrorMessage">
                              {this.props.displayerrorMessage.email}
                           </div>
                           </div>
                        </div>
                        <div className="form-group col-md-6 col-sm-6">
                           <div className="form-label">Phone Number</div>
                           <div
                           className={
                              this.props.displayerrorMessage.phone_no == "" ||
                              this.props.displayerrorMessage.phone_no == undefined
                                 ? "floating-label-input"
                                 : "floating-label-input invalid-input"
                           }
                           >
                           <TextField
                              className="astrick"
                              maxLength="10"
                              onKeyUp={(e) => validate.numericCheck(e)}
                              name="phone_no"
                              placeholder="e.g. (555) 555 -5555"
                              onChange={(e) =>
                                 this.props.onquoteTextFiledChangeValue(
                                 e,
                                 "phone_no",
                                 "Number"
                                 )
                              }
                              onBlur={(e) =>
                                 this.props.onquoteTextFiledChangeValue(
                                 e,
                                 "phone_no",
                                 "Number"
                                 )
                              }
                           />
                           <span className="error-icon icon-info-ico"></span>
                           <div className="errorMessage" id="numberErrorMessage">
                              {this.props.displayerrorMessage.phone_no}
                           </div>
                           </div>
                        </div>
                        <div className="form-group col-md-6 col-sm-6">
                           <div className="form-label">Zip Code</div>
                           <div
                           className={
                              this.props.displayerrorMessage.zipcode == "" ||
                              this.props.displayerrorMessage.zipcode == undefined
                                 ? "floating-label-input"
                                 : "floating-label-input invalid-input"
                           }
                           >
                           <TextField
                              maxLength="5"
                              className="astrick"
                              name="zipcode"
                              placeholder="e.g. 94132"
                              onKeyUp={(e) => validate.numericCheckForZipCode(e)}
                              onChange={(e) =>
                                 this.props.onquoteTextFiledChangeValue(
                                 e,
                                 "zipcode",
                                 "Zip Code"
                                 )
                              }
                              onBlur={(e) =>
                                 this.props.onquoteTextFiledChangeValue(
                                 e,
                                 "zipcode",
                                 "Zip Code"
                                 )
                              }
                           />
                           <span className="error-icon icon-info-ico"></span>
                           <div className="errorMessage" id="zcodeErrorMessage">
                              {this.props.displayerrorMessage.zipcode}
                           </div>
                           </div>
                        </div>
                        {
                           this.props.const_var.isKLinkEnable == false && !this.props.const_var.createLeadOnly && <div className="form-group col-md-6 col-sm-6">
                           <div className="form-label">Sensei Sales ID</div>
                           <div
                           className={
                              this.props.displayerrorMessage.sensei_sales_id == "" ||
                              this.props.displayerrorMessage.sensei_sales_id == undefined
                                 ? "floating-label-input"
                                 : "floating-label-input invalid-input"
                           }
                           >
                           <TextField
                              maxLength="6"
                              className="astrick"
                              name="sensei_sales_id"
                              placeholder="e.g. ABC123"
                              onChange={(e) =>
                                 this.props.onquoteTextFiledChangeValue(
                                 e,
                                 "sensei_sales_id",
                                 "Sensei Sales ID"
                                 )
                              }
                              onBlur={(e) =>
                                 this.props.onquoteTextFiledChangeValue(
                                 e,
                                 "sensei_sales_id",
                                 "Sensei Sales ID"
                                 )
                              }
                           />
                           <span className="error-icon icon-info-ico"></span>
                           <div className="errorMessage" id="zcodeErrorMessage">
                              {this.props.displayerrorMessage.sensei_sales_id}
                           </div>
                           </div>
                        </div>
                        }

                        <div className="form-group col-md-12 col-sm-12">
                           <div className="form-label">Address</div>
                           <div
                           className={
                              this.props.displayerrorMessage
                                 .shipping_address_line_1 == "" ||
                              this.props.displayerrorMessage
                                 .shipping_address_line_1 == undefined
                                 ? "floating-label-input"
                                 : "floating-label-input invalid-input"
                           }
                           >
                           <TextField
                              textarea
                              className="astrick textarea"
                              name="shipping_address_line_1"
                              placeholder="e.g. 3139 N Oakland Ave, Milwaukee, WI 53211, United States"
                              rows={this.props.crmSetting.main_domain_url == "keensbuildings.com" ? 1 : 3}
                              onChange={(e) =>
                                 this.props.onquoteTextFiledChangeValue(
                                 e,
                                 "shipping_address_line_1",
                                 "Installation Address"
                                 )
                              }
                              onBlur={(e) =>
                                 this.props.onquoteTextFiledChangeValue(
                                 e,
                                 "shipping_address_line_1",
                                 "Installation Address"
                                 )
                              }                           
                           />
                           <span className="error-icon icon-info-ico"></span>
                           <div
                              className="errorMessage"
                              id="installationaddressErrorMessage"
                           >
                              {
                                 this.props.displayerrorMessage
                                 .shipping_address_line_1
                              }
                           </div>
                           </div>
                        </div>
                        <div className="sales-center-container col-md-12 col-sm-12 d-none" onClick={() => this.showHideSenseiId()}>
                           <span className="sales-center-label">
                              Sales Center Information
                           </span>
                           <span className={`${this.state.showSenseiId ? "icon-close" : "icon-plus"}`}></span>
                        </div>
                        {
                           this.state.showSenseiId &&
                           <div className="senseiId-form-container form-group">
                              <div className="form-label">Sensei ID</div>
                              <div
                              className={
                                 this.props.displayerrorMessage.senseiId == "" ||
                                 this.props.displayerrorMessage.senseiId == undefined
                                    ? "floating-label-input"
                                    : "floating-label-input invalid-input"
                              }
                              >
                              <TextField
                                 maxLength="5"
                                 className="astrick"
                                 name="senseiId"
                                 placeholder="e.g. GHJH-9876-JHNM-JKOY"
                                 onChange={(e) =>
                                    this.props.onquoteTextFiledChangeValue(
                                    e,
                                    "senseiId",
                                    "Sensei ID"
                                    )
                                 }
                                 onBlur={(e) =>
                                    this.props.onquoteTextFiledChangeValue(
                                    e,
                                    "senseiId",
                                    "Sensei ID"
                                    )
                                 }
                              />
                              <span className="error-icon icon-info-ico"></span>
                              <div className="errorMessage" id="senseiIdErrorMessage">
                                 {this.props.displayerrorMessage.senseiId}
                              </div>
                              </div>
                           </div>
                        }
                        
                        {
                           this.props.crmSetting.main_domain_url == "keensbuildings.com"
                           ?
                              <div className="form-group col-md-12 col-sm-12 mb-0">
                                 <div className="keens-save-text mb-1">

                                    We will email you a PDF with this building’s features and
                                    total price. You can anytime call us at{" "}
                                    <span>{this.props.crmSetting.phone_number}{" "}</span>
                                    {CustomTextLD} 
                                 </div>
                              </div>
                           :
                           null
                        }

                        {/* <div className="form-group col-md-6 col-sm-12">
                           <div
                              className={
                                 this.props.displayerrorMessage.sensei_id == "" ||
                                 this.props.displayerrorMessage.sensei_id == undefined
                                    ? "floating-label-input"
                                    : "floating-label-input invalid-input"
                              }
                           >
                           <div className="form-label">Sensei Id</div>
                           <TextField
                              className="label-for-referral"
                              name="sensei_id"
                              onChange={(e) =>
                                 this.props.onquoteTextFiledChangeValue(
                                 e,
                                 "sensei_id",
                                 "Sensei Id"
                                 )
                              }
                              onBlur={(e) =>
                                 this.props.onquoteTextFiledChangeValue(
                                 e,
                                 "sensei_id",
                                 "Sensei Id"
                                 )
                              }
                           />
                           <span className="error-icon icon-info-ico"></span>
                           <div className="errorMessage" id="numberErrorMessage">
                              {this.props.displayerrorMessage.sensei_id}
                           </div>
                           </div>
                        </div> */}
                        {
                           this.props.const_var?.estimator_QuestionAnswer?.length > 0 && !this.props.const_var.createLeadOnly &&
                              <div className={this.props.crmSetting.main_domain_url == "keensbuildings.com" ? "form-group col-md-12 col-sm-12 mb-0" : "form-group col-md-12 col-sm-12"}>
                                 <Questions isNameofModule="quote" />
                              </div>
                        }
                     </div>
                     <div className={this.props.crmSetting.main_domain_url == "keensbuildings.com" ? "save-footer keens-save-footer" : "save-footer"}>
                        <div>
                           {/* <button className={"btn btn-secondary quote-primary"} onClick={(e) => {e.preventDefault();this.custom()}}>
                              CANCEL
                           </button> */}
                           <button
                              type="submit"
                              className={'btn btn-primary save-btn-non-log'}
                           >
                              <span className="text">SAVE</span>
                              <span className="saving-effect"><span></span><span></span><span></span></span>
                           </button>
                        </div>
                     </div>
                  </form>
               </div>
               </div>
            </div>
         </Modal.Body>
      
      </Modal>
      {this.props.pdfURL != "" ? (
         <ThankYou
         show={this.props.thankYouForSaveLater}
         handleClose={this.closeModal}
         Qpdf_url={this.props.pdfURL}
         thankYouForSaveLater={this.props.thankYouForSaveLater}
         phone_number={this.props.crmSetting.phone_number}
         domain_url={this.props.crmSetting.main_domain_url}
         />
      ) : null}
      {(this.props.pdfURL == "" || (this.props.const_var.crmSetting.main_domain_url == 'metalcarportdepotllc.com' && this.props.const_var.leadCreatedSuccessfully)) ? (
         <CommonPromptBox
         show={this.state.showModal}
         handleClose={this.closeModal}
         message={this.props.alertUsedMSG}
         />
      ) : null}
   </div>
   );
  }
}

const mapStateToProps = (state) => {
  return {...state.quoteReducer, ...state.reducer};
};

export default connect(mapStateToProps, actionCreator)(SaveLater);
